import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { getPersistor } from '@rematch/persist'
import { LocaleProvider } from 'antd'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import { Router } from 'react-router-dom'
import history from '-/utils/history'
import Routes from '-/routes'
import store from '-/store/index'
// FIXME: 新版本解决声明文件的问题后去除下面的注释
// @ts-ignore
import webReportSdk from '@doctorwork/web-report-sdk'
import 'moment/locale/zh-cn'

const persistor = getPersistor()

export const monitor = webReportSdk({
  appId: String(process.env.REACT_APP_REPORT_APP_ID),
  env: String(process.env.REACT_APP_DEPLOY_ENV),
  filterUrls: ['/api/v1/warning/notice', '/api/v1/prescription', '/api/v1/order/new'],
  domain: String(process.env.REACT_APP_REPORT_APP_DOMAIN),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errcodeReport(res: any) {
    if (
      Object.prototype.toString.call(res) === '[object Object]' &&
      // eslint-disable-next-line no-prototype-builtins
      res.hasOwnProperty('errcode') &&
      res.errcode !== 0
    ) {
      return { isReport: true, errMsg: res.errmsg, code: res.errcode }
    }
    return { isReport: false }
  },
  isTraceId: true,
  traceIdHeaderName: 'x-trace-id',
})

const App = (): JSX.Element => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <LocaleProvider locale={zhCN}>
            <Routes />
          </LocaleProvider>
        </Router>
      </PersistGate>
    </Provider>
  )
}

export default App
